import { render, staticRenderFns } from "./PrintTicketRegaloLayout.vue?vue&type=template&id=551a1a4e&scoped=true&"
import script from "./PrintTicketRegaloLayout.vue?vue&type=script&lang=js&"
export * from "./PrintTicketRegaloLayout.vue?vue&type=script&lang=js&"
import style0 from "./PrintTicketRegaloLayout.vue?vue&type=style&index=0&id=551a1a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a1a4e",
  null
  
)

export default component.exports